/**
 * Created by Ammar Raufi on 1/7/2018.
 */
export enum Result {
  'win','lose','noResult'
}



// WEBPACK FOOTER //
// ./src/app/minesweeper/constants/Result.ts